/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { Component, lazy } from "react";

const AddYourProductPage = lazy(
    () => import("../../../../pages/AddYourProduct")
);
const CreateQRCodesPage = lazy(() => import("../../../../pages/CreateQRCodes"));
const NetworkOperatorScreen = lazy(
    () => import("../../../../pages/NetworkOperator")
);
const AnalyticsScreen = lazy(() => import("../../../../pages/Analytics"));
const ProductScreen = lazy(() => import("../../../../pages/Products"));
const ProductDetailScreen = lazy(
    () => import("../../../../pages/ProductDetail")
);
const GtinDetailScreen = lazy(() => import("../../../../pages/GtinDetail"));
const BatchDetailScreen = lazy(() => import("../../../../pages/BatchDetail"));
const TransactionScreen = lazy(
    () => import("../../../../pages/TransactionsTable")
);
const TransactionDetailScreen = lazy(
    () => import("../../../../pages/TransactionDetails")
);
const TransactionTableScreen = lazy(
    () => import("../../../../pages/TransactionsBrandTable")
);
const DiageoProductWBTransactionPage = lazy(
    () => import("../../../../pages/DiageoProductWBTransaction")
);
const TragProductTransactionPage = lazy(
    () => import("../../../../pages/TragProductTransaction")
);
const CampaignScreen = lazy(() => import("../../../../pages/Campaigns"));
const NewCampaignScreen = lazy(() => import("../../../../pages/NewCampaigns"));
const PersonaScreenDesc = lazy(() => import("../../../../pages/PersonasDesc"));
const PersonaScreen = lazy(() => import("../../../../pages/Personas"));
const PersonaScreenTable = lazy(
    () => import("../../../../pages/PersonasTable")
);
const AddNewPersonaPage = lazy(() => import("../../../../pages/AddNewPersona"));
const FeedbackScreen = lazy(() => import("../../../../pages/Feedback"));
const ProvenanceScreen = lazy(() => import("../../../../pages/Provenance"));
const ProvenanceDetailScreen = lazy(
    () => import("../../../../pages/ProvenanceDetails")
);
const AssortmentBatchesScreen = lazy(
    () => import("../../../../pages/AssortmentBatches")
);
const NewAssortmentBatchesScreen = lazy(
    () => import("../../../../pages/NewAssortmentBatches")
);
const AssortmentRangesScreen = lazy(
    () => import("../../../../pages/AssortmentRanges")
);
const NewAssortmentRangesScreen = lazy(
    () => import("../../../../pages/NewAssortmentRanges")
);
const DraftAssetsDescriptionScreen = lazy(
    () => import("../../../../pages/DraftAssetsDetail")
);
const CollectiblesFormScreen = lazy(
    () => import("../../../../pages/NewCollections")
);
const CreateCollectableScreen = lazy(
    () => import("../../../../pages/CreateCollectables")
);
const RolesPage = lazy(() => import("../../../../pages/Roles"));
const CreatePersonaRolePage = lazy(
    () => import("../../../../pages/CreatePersonaRole")
);
const UploadCollectionScreen = lazy(
    () => import("../../../../pages/UploadCollection")
);
const DownloadTemplateScreen = lazy(
    () => import("../../../../pages/DownloadTemplate")
);

const BatchLevelQRScreen = lazy(() => import("../../../../pages/BatchLevelQR"));
const AdminBatchLevelQRScreen = lazy(
    () => import("../../../../pages/AdminViewBatchLevelQR")
);

const UsersProfileDescriptionPage = lazy(
    () => import("../../../../pages/UsersProfileDescription")
);
const UsersTablePage = lazy(() => import("../../../../pages/UsersTable"));
const AddNewUserPage = lazy(() => import("../../../../pages/AddNewUser"));

const SapTablePage = lazy(() => import("../../../../pages/Sap"));
const ReportPage = lazy(() => import("../../../../pages/Report"));

const SocialMediaHandlesPage = lazy(
    () => import("../../../../pages/SocialMediaHandles")
);

const CampaignInfoPage = lazy(() => import("../../../../pages/CampaignInfo"));
const BatchSerializationInfoPage = lazy(
    () => import("../../../../pages/BatchSerializationInfo")
);
const ItemSerializationInfoPage = lazy(
    () => import("../../../../pages/ItemSerializationInfo")
);

const FAQPage = lazy(() => import("../../../../pages/FAQ"));
const MasterDispatchTablePage = lazy(
    () => import("../../../../pages/MasterDispatchAnalytics")
);
const DispatchTablePage = lazy(
    () => import("../../../../pages/DispatchAnalytics")
);
const ClubRegistrationPage = lazy(
    () => import("../../../../pages/ClubRegistration")
);
const DashboardOverviewPage = lazy(() => import("../../../../pages/Dashboard"));
const ProvenanceTemplatesScreen = lazy(
    () => import("../../../../pages/ProvenanceTemplates")
);
const ProvenanceTemplatesDetailScreen = lazy(
    () => import("../../../../pages/ProvenanceTemplatesDetail")
);

export const routes = [
    { path: "/club-registration", Component: ClubRegistrationPage },
    { path: "/faq", Component: FAQPage },
    { path: "/manufacturer", Component: NetworkOperatorScreen },
    { path: "/analytics", Component: AnalyticsScreen },
    { path: "/products", Component: ProductScreen },
    { path: "/products/detail", Component: ProductDetailScreen },
    { path: "/gtins/detail", Component: GtinDetailScreen },
    { path: "/batches/detail", Component: BatchDetailScreen },
    { path: "/transactions", Component: TransactionScreen },
    { path: "/transactions-details", Component: TransactionDetailScreen },
    {
        path: "/transactions/brandprotection",
        Component: TransactionTableScreen,
    },
    {
        path: "/transactions/wb-authenticity-scans",
        Component: DiageoProductWBTransactionPage,
    },
    {
        path: "/transactions/wb-generic-product",
        Component: TragProductTransactionPage,
    },
    { path: "/campaigns-info", Component: CampaignInfoPage },
    { path: "/campaigns", Component: CampaignScreen },
    { path: "/new-campaign", Component: NewCampaignScreen },
    { path: "/personas", Component: PersonaScreenDesc },
    { path: "/personas/template", Component: PersonaScreen },
    { path: "/personas/table", Component: PersonaScreenTable },
    { path: "/personas/new-person", Component: AddNewPersonaPage },
    { path: "/roles", Component: RolesPage },
    { path: "/roles/create-role", Component: CreatePersonaRolePage },
    { path: "/feedback", Component: FeedbackScreen },
    { path: "/provenance", Component: ProvenanceScreen },
    { path: "/provenance/detail", Component: ProvenanceDetailScreen },
    {
        path: "/batch-serialization-info",
        Component: BatchSerializationInfoPage,
    },
    { path: "/assortment-batches", Component: AssortmentBatchesScreen },
    { path: "/new-assortment-batch", Component: NewAssortmentBatchesScreen },
    { path: "/item-serialization-info", Component: ItemSerializationInfoPage },
    { path: "/assortment-ranges", Component: AssortmentRangesScreen },
    { path: "/new-assortment-range", Component: NewAssortmentRangesScreen },
    {
        path: "/draft-asset-description",
        Component: DraftAssetsDescriptionScreen,
    },
    { path: "/new-collection", Component: CollectiblesFormScreen },
    { path: "/create-collectibles", Component: CreateCollectableScreen },
    { path: "/upload-collection", Component: UploadCollectionScreen },
    { path: "/templates", Component: DownloadTemplateScreen },
    { path: "/batch-level-qr", Component: BatchLevelQRScreen },
    { path: "/admin-level-qr", Component: AdminBatchLevelQRScreen },
    { path: "/users-profile", Component: UsersProfileDescriptionPage },
    { path: "/users-table", Component: UsersTablePage },
    { path: "/new-user", Component: AddNewUserPage },
    { path: "/sap-analytics", Component: SapTablePage },
    { path: "/master-dispatch", Component: MasterDispatchTablePage },
    { path: "/dispatch-table", Component: DispatchTablePage },
    { path: "/report", Component: ReportPage },
    { path: "/manufacturer/social-handles", Component: SocialMediaHandlesPage },
    { path: "/diy-work-flow", Component: AddYourProductPage },
    { path: "/create-qr-codes", Component: CreateQRCodesPage },
    { path: "/", Component: DashboardOverviewPage },
    { path: "/provenance/templates", Component: ProvenanceTemplatesScreen },
    {
        path: "/provenance/template-details",
        Component: ProvenanceTemplatesDetailScreen,
    },
];
